// extracted by mini-css-extract-plugin
module.exports = {"react-player":"video_react-player__nToUj","w-video-wrapper":"video_w-video-wrapper__8197_","wistia_embed":"video_wistia_embed__oUftv"};